import * as React from 'react';
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';

import './navbar.css'

export default class Navigator extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = { 
      isCollapsed: false,
      firstCall: false
    }
  }

  public render() {

    return (
      <Navbar id="navbar" collapseOnSelect={true}>
        <Navbar.Header id="header-nav">
          <Navbar.Brand />
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <NavItem eventKey={1} href="/">Home</NavItem>
            <NavItem eventKey={2} href="/about-us/">About Us</NavItem>
            <NavItem eventKey={3} href="/services/">Services</NavItem>
            <NavDropdown eventKey={4} title="Gallery" id="basic-nav-dropdown">
              <MenuItem eventKey={4.1} href="/gallery-la/">Landscape</MenuItem>
              <MenuItem eventKey={4.2} href="/gallery-db/">Design-Build</MenuItem>
              <MenuItem eventKey={4.3} href="/gallery-pl/">Pool & Spa</MenuItem>
            </NavDropdown>
            <NavItem eventKey={5} href="/contact-us/">Contact Us</NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/navbar.tsx